import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

import { HeatStrength } from '#/@types/backend'
import Colors from '#/styles/Colors'

const EMPTY_BAR_COLOR = '#D9D9D9'

type HeatStrengthIconProps = SvgIconProps & {
  status?: HeatStrength
}

const HeatStrengthIcon: React.FC<HeatStrengthIconProps> = ({ status = 3, ...rest }) => {
  const barColor = (bar: number) => (bar < status ? Colors.heatStrength[status] : EMPTY_BAR_COLOR)

  return (
    /* prettier-ignore */
    <SvgIcon viewBox="0 0 24 24" {...rest}>
      <rect x="1.79913" y="15.1619" width="3.54502" height="3.09781" rx="1.77251" fill={barColor(0)}/>
      <rect x="6.01355" y="12.6410" width="3.54502" height="5.61917" rx="1.77251" fill={barColor(1)}/>
      <rect x="10.2273" y="9.97473" width="3.54502" height="8.28484" rx="1.77251" fill={barColor(2)}/>
      <rect x="14.4421" y="7.74188" width="3.54502" height="10.5182" rx="1.77251" fill={barColor(3)}/>
      <rect x="18.6558" y="5.73987" width="3.54502" height="12.5199" rx="1.77251" fill={barColor(4)}/>
    </SvgIcon>
  )
}
export default HeatStrengthIcon
